<template>
  <div class="our-services-wrapper">
    <section class="services-hero">
      <div class="hero-particles"></div>
      <div class="hero-gradient-overlay"></div>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10" lg="8">
            <div class="hero-content">
              <div class="hero-badge" data-aos="fade-down">
                <div class="badge-shimmer"></div>
                <v-icon small color="#f46523" class="mr-2">mdi-tools</v-icon>
                <span>Professional Services</span>
              </div>

              <h1 class="hero-title" data-aos="fade-up" data-aos-delay="100">
                Our Services
              </h1>

              <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
                Maintenance made easy. View our whole service portfolio!
              </p>

              <div
                class="hero-features"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div
                  class="hero-feature"
                  v-for="(f, i) in heroFeatures"
                  :key="i"
                >
                  <v-icon color="#f46523">mdi-check-circle</v-icon>
                  <span>{{ f }}</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <div class="hero-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28..."
            opacity=".25"
            class="wave-fill"
          />
        </svg>
      </div>
    </section>
    <section class="services-section">
      <div class="floating-elements">
        <div class="float-element float-1"></div>
        <div class="float-element float-2"></div>
        <div class="float-element float-3"></div>
      </div>
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <div class="services-grid">
              <div
                class="service-card"
                v-for="(service, index) in services"
                :key="index"
                :class="service.featured ? 'featured' : ''"
                data-aos="fade-up"
                :data-aos-delay="100 * (index + 1)"
              >
                <div class="service-card-glow"></div>
                <div v-if="service.ribbon" class="featured-ribbon">
                  <v-icon small class="mr-1">mdi-star</v-icon>
                  <span>{{ service.ribbon }}</span>
                </div>

                <div class="service-image-wrapper">
                  <div class="image-overlay"></div>
                  <img
                    :src="service.image"
                    :alt="service.title"
                    class="service-image"
                  />
                  <div class="service-badge" :class="service.badgeClass">
                    <v-icon small color="white" class="mr-1">{{
                      service.badgeIcon
                    }}</v-icon>
                    <span>{{ service.badgeText }}</span>
                  </div>
                </div>

                <div class="service-content">
                  <div class="service-icon">
                    <div class="icon-glow"></div>
                    <v-icon color="#f46523" size="32">{{
                      service.icon
                    }}</v-icon>
                  </div>

                  <h3 class="service-title">{{ service.title }}</h3>
                  <p class="service-description">{{ service.description }}</p>

                  <div class="service-features">
                    <div
                      class="feature-item"
                      v-for="(feature, i) in service.features"
                      :key="i"
                    >
                      <v-icon small color="#f46523">mdi-check</v-icon>
                      <span>{{ feature }}</span>
                    </div>
                  </div>
                  <v-btn
                    depressed
                    color="#f46523"
                    dark
                    style="height: 40px"
                    @click="
                      $router.push({
                        name: 'ServicesDetails',
                        params: { serviceName: service.title },
                      })
                    "
                  >
                    <span>Book Now</span>
                    <v-icon right small>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div class="cta-section" data-aos="zoom-in-up">
              <div class="cta-glow"></div>
              <div class="cta-content-wrapper">
                <div class="cta-icon-wrapper">
                  <div class="cta-icon-ring"></div>
                  <v-icon color="#f46523" size="64">mdi-phone-in-talk</v-icon>
                </div>

                <div class="cta-text-content">
                  <h2 class="cta-title">Need a Service Right Away?</h2>
                  <p class="cta-subtitle">
                    Our team is available 24/7 to assist you with any home
                    service emergency
                  </p>
                </div>

                <div class="cta-buttons">
                  <a href="tel:+917356449135" class="cta-phone-link">
                    <v-icon left size="30" color="#f46523"
                      >mdi-phone-in-talk</v-icon
                    >
                    <span class="cta-phone-number">+91 70344 44303</span>
                  </a>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "OurServices",
  data() {
    return {
      heroFeatures: [
        "Verified Professionals",
        "24/7 Availability",
        "Quality Guaranteed",
      ],
      services: [
        {
          title: "Best Plumbing Service",
          icon: "mdi-pipe-wrench",
          image:
            "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&q=80",
          badgeText: "Popular",
          badgeIcon: "mdi-star",
          badgeClass: "",
          description:
            "Expert plumbers for all your residential and commercial needs. From leak repairs to installations — available 24/7.",
          features: [
            "Emergency Repairs",
            "Pipe Installation",
            "Drain Cleaning",
          ],
        },
        {
          title: "Home Painting Service",
          icon: "mdi-format-paint",
          image:
            "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&q=80",
          badgeText: "Trending",
          badgeIcon: "mdi-trending-up",
          badgeClass: "trending",
          description:
            "Transform your space with our professional painting services — expert finishes and color consultation.",
          features: [
            "Interior Painting",
            "Exterior Painting",
            "Color Consultation",
          ],
        },
        {
          title: "Deep Cleaning Services",
          icon: "mdi-spray-bottle",
          image:
            "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80",
          badgeText: "Recommended",
          badgeIcon: "mdi-thumb-up",
          badgeClass: "recommended",
          description:
            "Comprehensive eco-friendly cleaning solutions for a spotless home or office.",
          features: [
            "Home Sanitization",
            "Kitchen Deep Clean",
            "Bathroom Cleaning",
          ],
        },
        {
          title: "Electrician Service",
          icon: "mdi-flash",
          image:
            "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80",
          badgeText: "Quick",
          badgeIcon: "mdi-lightning-bolt",
          badgeClass: "",
          description:
            "Licensed electricians for all your wiring, installation, and repair needs — safe and reliable service.",
          features: [
            "Wiring & Rewiring",
            "Safety Inspection",
            "Fixture Installation",
          ],
        },
        {
          title: "Air Conditioner Repair Service",
          icon: "mdi-air-conditioner",
          image:
            "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80",
          badgeText: "Featured",
          badgeIcon: "mdi-snowflake",
          badgeClass: "featured-badge",
          featured: true,
          ribbon: "Most Booked",
          description:
            "Keep cool with our expert AC repair and maintenance. Fast, affordable, and skilled technicians.",
          features: ["AC Installation", "Regular Maintenance", "Gas Refilling"],
        },
      ],
    };
  },
  methods: {
    bookService(serviceName) {
      this.$emit("notify", {
        type: "success",
        message: `Booking ${serviceName} service...`,
      });
    },
  },
};
</script>

<style scoped>
@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-25px);
  }
}

@keyframes gradientShift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(200%) rotate(45deg);
  }
}

@keyframes glow {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.our-services-wrapper {
  background: white;
  position: relative;
  padding-top: 50px;
  overflow: hidden;
}

.services-hero {
  position: relative;
  padding: 40px 0 0;
  overflow: hidden;
}

.hero-particles {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: radial-gradient(
      2px 2px at 20% 30%,
      rgba(244, 101, 35, 0.3),
      transparent
    ),
    radial-gradient(2px 2px at 60% 70%, rgba(244, 101, 35, 0.2), transparent),
    radial-gradient(1px 1px at 50% 50%, rgba(244, 101, 35, 0.2), transparent),
    radial-gradient(1px 1px at 80% 10%, rgba(244, 101, 35, 0.3), transparent);
  background-size: 200% 200%;
  animation: gradientShift 20s ease infinite;
}

.hero-gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgba(244, 101, 35, 0.08) 0%,
    transparent 70%
  );
  pointer-events: none;
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 2;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 10px 24px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  border-radius: 50px;
  border: 1px solid rgba(244, 101, 35, 0.3);
  box-shadow: 0 4px 20px rgba(244, 101, 35, 0.1);
  margin-bottom: 24px;
  font-size: 13px;
  font-weight: 600;
  color: black;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: shimmer 3s infinite;
}

.hero-title {
  font-size: 64px;
  font-weight: 900;
  background: #f46523;
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 16px;
  line-height: 1.1;
  animation: gradientShift 8s ease infinite;
  letter-spacing: -1.5px;
}

.hero-subtitle {
  font-size: 20px;
  color: black;
  margin-bottom: 32px;
  font-weight: 400;
}

.hero-features {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.hero-feature {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(8px);
  border-radius: 50px;
  border: 1px solid rgba(244, 101, 35, 0.15);
  color: black;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.hero-feature:hover {
  background: rgba(244, 101, 35, 0.1);
  border-color: rgba(244, 101, 35, 0.3);
  transform: translateY(-2px);
}

.hero-wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.hero-wave svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 60px;
}

.wave-fill {
  fill: #0a0a0a;
}

.services-section {
  padding: 60px 0 80px;
  position: relative;
}

.floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
}

.float-element {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(244, 101, 35, 0.05), transparent);
  filter: blur(50px);
}

.float-1 {
  width: 400px;
  height: 400px;
  top: 10%;
  left: -5%;
  animation: float 25s ease-in-out infinite;
}

.float-2 {
  width: 300px;
  height: 300px;
  top: 70%;
  right: -5%;
  animation: float 20s ease-in-out infinite reverse;
}

.float-3 {
  width: 250px;
  height: 250px;
  bottom: 5%;
  left: 40%;
  animation: float 22s ease-in-out infinite;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

@media (min-width: 1264px) {
  .services-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.service-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  border: 1px solid rgba(244, 101, 35, 0.15);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  display: flex;
  cursor: pointer;
  flex-direction: column;
}

.service-card.featured {
  border: 2px solid rgba(244, 101, 35, 0.3);
}

.featured-ribbon {
  position: absolute;
  top: 15px;
  right: -25px;
  padding: 6px 30px;
  font-size: 12px;
  transform: rotate(45deg);
  box-shadow: 0 2px 10px rgba(244, 101, 35, 0.3);
  background: #f46523;
  color: white;
  z-index: 10;
}

.service-card-glow {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.5s;
}

.service-card:hover .service-card-glow {
  opacity: 0.8;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 45px rgba(244, 101, 35, 0.25);
  border-color: rgba(244, 101, 35, 0.4);
}

.service-image-wrapper {
  position: relative;
  height: 200px;
  overflow: hidden;
  flex-shrink: 0;
}

.service-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-card:hover .service-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    transparent 0%,
    rgba(10, 10, 10, 0.6) 100%
  );
}

.service-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 6px 12px;
  font-size: 11px;
  box-shadow: 0 2px 8px rgba(244, 101, 35, 0.3);
  background: #f46523;
  border-radius: 5px;
  color: white;
  font-weight: 600;
  z-index: 10;
}
.service-badge.trending {
  background: #4caf50;
}
.service-badge.recommended {
  background: #2196f3;
}
.service-badge.featured-badge {
  background: #ff9800;
}

.service-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.service-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  margin-bottom: 16px;
  border: 1px solid rgba(244, 101, 35, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(244, 101, 35, 0.1);
  position: relative;
}

.icon-glow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(244, 101, 35, 0.5), transparent 70%);
  opacity: 0.3;
  border-radius: 12px;
  filter: blur(10px);
}

.service-title {
  color: black;
  font-size: 24px;
  margin-bottom: 8px;
}

.service-description {
  color: black;
  font-size: 15px;
  line-height: 1.4;
  margin-bottom: 16px;
  flex-grow: 1;
}

.service-features {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.feature-item {
  color: black;
  font-size: 14px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.feature-item v-icon {
  font-size: 16px !important;
}

.service-btn {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  height: 30px;
}
.service-btn:hover {
  background-color: #e05e1f !important;
  transform: translateY(-1px);
  height: 30px;
}

.cta-section {
  background: white;
  border-radius: 20px;
  padding: 30px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(244, 101, 35, 0.2);
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
}

.cta-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle at 100px 100px,
    rgba(244, 101, 35, 0.1),
    transparent 70%
  );
  animation: rotate 60s linear infinite;
  opacity: 0.5;
}

.cta-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  position: relative;
  z-index: 1;
}

@media (max-width: 960px) {
  .cta-content-wrapper {
    flex-direction: column;
    text-align: center;
  }
}

.cta-icon-wrapper {
  position: relative;
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cta-icon-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid rgba(244, 101, 35, 0.4);
  border-radius: 50%;
  animation: pulse 2s infinite ease-in-out;
}

.cta-text-content {
  flex-grow: 1;
}

.cta-title {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 8px;
  line-height: 1.2;
  color: black;
}

.cta-subtitle {
  font-size: 16px;
  color: black;
  font-weight: 300;
}

.cta-buttons {
  display: flex;
  gap: 15px;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .cta-buttons {
    flex-direction: column;
    width: 100%;
  }
  .cta-buttons .v-btn {
    width: 100%;
  }
}

.cta-primary-btn {
  font-weight: 700;
  letter-spacing: 1px;
  transition: background-color 0.3s, transform 0.3s;
}
.cta-primary-btn:hover {
  background-color: #e05e1f !important;
  transform: translateY(-1px);
}

.cta-secondary-btn {
  font-weight: 600;
  letter-spacing: 1px;
  transition: background-color 0.3s, transform 0.3s;
}
.cta-secondary-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-1px);
}
.cta-phone-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 20px;
  font-weight: 800;
  color: #f46523 !important;
  padding: 10px 20px;
  border-radius: 12px;
  transition: all 0.3s;
  flex-shrink: 0;
}

.cta-phone-link:hover {
  background: rgba(244, 101, 35, 0.2);
  transform: translateY(-2px);
}

.cta-phone-number {
  margin-left: 10px;
}

@media (max-width: 960px) {
  .cta-phone-link {
    width: 100%;
    margin-bottom: 15px; /* Add space above the Schedule button on mobile */
  }
}
</style>
